<template>
  <div class="main">
    <c-panel title="Rotas" titleIcon="fas fa-map-signs">
      <list></list>
    </c-panel>
  </div>
</template>

<script>
import list from "./list"

export default {
  components: { list }
}
</script>

